import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function ViewInsurance() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const data = state?.insurance;

  if (!data) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="col-12">
            <div className="card table-card">
              <div className="tableHeader">
                <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                    onClick={() => navigate(-1)}
                    title="Back"
                  >
                    &larr;
                  </span>
                  Insurance Details
                </h5>
              </div>
              <div className="card-body" style={{ margin: "15px" }}>
                <div className="alert alert-warning">No data provided for ID {id}. Open from Insurance list.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                Insurance Details
              </h5>
            </div>
            <div className="card-body" style={{ margin: "15px" }}>
              <div className="row">
                {[
                  ["Date", new Date(data.date).toLocaleDateString("en-GB")],
                  ["Company", data.company],
                  // ["Claim No", data.claimNo],
                  ["Patient", data.patient_name],
                  ["Policy ID", data.policy_id],
                  ["Ins Amount", `${data.amount}${data.currency ? ` ${data.currency}` : ""}`],
                  ["Status", data.status],


                ].map(([label, value], idx) => (
                  <div className="col-md-6 mb-3" key={idx}>
                    <label className="form-label">{label}</label>
                    <input type="text" className="form-control" value={value ?? ""} disabled />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



